import * as React from 'react';

import PromoTemplatePageWrapper from 'bundles/promo-template/components/PromoTemplatePageWrapper';
import { DOMAINS } from 'bundles/promo-template/constants/navigation';

const ExploreDomain = () => {
  return <PromoTemplatePageWrapper domain={DOMAINS.explore} />;
};

export default ExploreDomain;
